export default {
  data() {
    return {
      tableHeight: 0
    };
  },
  computed: {},
  methods: {
    handleSearchFormChange() {
      if (!this.$store) {
        return;
      }
      this.$store.dispatch('computedTableHeight').then(() => {
        let height = this.$store.state.height;
        this.tableHeight = height;
      });
    }
  },
  mounted() {
    this.handleSearchFormChange();

  },
};



// WEBPACK FOOTER //
// ./src/mixins/computed-table-height.js